import type { LogicConditionNode } from '../model';

export const resolveInitialConditionOperator = (node: LogicConditionNode, operatorOptions: string[]): string => {
    if (node.operator && operatorOptions.includes(node.operator)) return node.operator;

    return operatorOptions[0] ?? '=';
};
